import axios from 'axios';
import { apiClient } from './client.api';

interface AuthResponse {
  accessToken: string;
  profileComplete: boolean;
}

export const authApi = {
  googleLogin: async (credential: string): Promise<AuthResponse> => {
    try {
      const response = await apiClient.post('/auth/google', { credential });
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data || error.message || 'Failed to sign in with Google');
      }
      throw error;
    }
  },
};
